import { isUndNullEmp } from '../../helpers/main.js';

export class Parameter {
    constructor(
        _id = 0,
        _customerId = 0,
        _register = '',
    ) {
        this.id = _id;
        this.customerId = _customerId;
        this.register = _register;
    }

    static getClassName = () => {
        return 'Parameter - class';
    }

    static minMaxLength = (upperCase = false) => {
        if (upperCase) {
            return {
                min: {
                    Id: 0,
                    CustomerId: 0,
                    Register: 10,
                },
                max: {
                    Id: 450,
                    customerId: 450,
                    Register: 30,
                },
            };
        } else {
            return {
                min: {
                    id: 0,
                    customerId: 0,
                    register: 10,
                },
                max: {
                    id: 450,
                    customerId: 450,
                    register: 30,
                },
            };
        }
    }

    // static userIdFullPath = ({userId = '', subMethod = ''} = {}) => {
    //     let response = getResponse({ type: 0 });
    //     const currentMethod = 'Parameter / userIdFullPath';
    //     try {
    //         if(!isUndNullEmp({data: userId, subMethod: currentMethod})?.result){
    //             userId = userId.replace('~/Images/UserIds/Parameter/', `${settings.backend.urls.imageUserIds}${settings.backend.urls.paymentInformations}/`);
    //             response.result = `${settings.backend.urls.api}${userId}`
    //         } else {
    //             response.result = `${settings.backend.urls.api}${settings?.images?.noImage}`;
    //         }
    //     } catch (ex) {
    //         response.isSuccess = false;
    //         response.msgType = -1;
    //         response.msgText = `Method: ${currentMethod}<br/>`;
    //         if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
    //             response.msgText += `Sub method: ${subMethod}<br/>`;
    //         }
    //         response.msgText += `Error: ${ex?.message}<br/>`;
    //     }
    //     return response;
    // }

    static getClass = (obj = {}, upperCase = false) => {
        if (!isUndNullEmp({ data: obj, subMethod: Parameter.getClassName() })?.result) {
            if (upperCase) {
                return new Parameter(
                    obj.Id,
                    obj.CustomerId,
                    obj.Register,
                );
            } else {
                return new Parameter(
                    obj.id,
                    obj.customerId,
                    obj.register,
                );
            }
        } else {
            return new Parameter();
        }
    }
}